// Generate code from clean architecture template

import { CourseTopicEntity } from '../entities';
import { CourseTopicRepository } from '../ports/repositories';

export class FindCourseTopicUsecase {
  constructor(private readonly repo: CourseTopicRepository) {}

  async run(id: string): Promise<CourseTopicEntity> {
    const data = await this.repo.getDetailCourseTopic(id);
    return data;
  }
}
